// 主题配色配置
export const themeConfigs = {
  // 绿色主题
  green: {
    token: {
      colorPrimary: '#89b96a',
      colorSuccess: '#52c41a',
      colorWarning: '#faad14',
      colorError: '#ff4d4f',
      colorInfo: '#89b96a',
      borderRadius: 6,
    },
  },
  
  // 金色主题
  gold: {
    token: {
      colorPrimary: '#f0c674',
      colorSuccess: '#52c41a',
      colorWarning: '#faad14',
      colorError: '#ff4d4f',
      colorInfo: '#f0c674',
      borderRadius: 6,
    },
  },
  
  // 青色主题
  cyan: {
    token: {
      colorPrimary: '#5cdbd3',
      colorSuccess: '#52c41a',
      colorWarning: '#faad14',
      colorError: '#ff4d4f',
      colorInfo: '#5cdbd3',
      borderRadius: 6,
    },
  },
  
  // 蓝色主题
  blue: {
    token: {
      colorPrimary: '#69c0ff',
      colorSuccess: '#52c41a',
      colorWarning: '#faad14',
      colorError: '#ff4d4f',
      colorInfo: '#69c0ff',
      borderRadius: 6,
    },
  },

  // 紫色主题
  purple: {
    token: {
      colorPrimary: '#b37feb',
      colorSuccess: '#52c41a',
      colorWarning: '#faad14',
      colorError: '#ff4d4f',
      colorInfo: '#b37feb',
      borderRadius: 6,
    },
  },

  // 橙色主题
  orange: {
    token: {
      colorPrimary: '#ffa940',
      colorSuccess: '#52c41a',
      colorWarning: '#faad14',
      colorError: '#ff4d4f',
      colorInfo: '#ffa940',
      borderRadius: 6,
    },
  },
};

// 获取当前主题
export const getCurrentTheme = () => {
  const savedTheme = localStorage.getItem('theme') || 'green'; // 默认绿色主题
  return themeConfigs[savedTheme] || themeConfigs.green;
};

// 设置主题
export const setTheme = (themeName) => {
  if (themeConfigs[themeName]) {
    localStorage.setItem('theme', themeName);
    return true;
  }
  return false;
};

// 获取所有可用主题
export const getAvailableThemes = () => {
  return Object.keys(themeConfigs).map(key => ({
    key,
    name: getThemeDisplayName(key),
    color: themeConfigs[key].token.colorPrimary,
  }));
};

// 获取主题显示名称
const getThemeDisplayName = (themeKey) => {
  const themeNames = {
    green: '绿色主题',
    gold: '黑金主题',
    cyan: '青色主题',
    blue: '蓝色主题',
    purple: '紫色主题',
    orange: '橙色主题',
  };
  return themeNames[themeKey] || themeKey;
};
